import { resourceAccommodationZodObject } from "@@/shared/acquire/resources/resource-accommodation/resource-accommodation";
import { isResourceGlobal } from "@@/shared/acquire/resources/resource-global";
import { resourceTableGroupZodObject } from "@@/shared/acquire/resources/resource-table-group";
import { assertTypeMatch } from "@@/utilities/type-helpers";
import type { IsEqual } from "type-fest";
import { z } from "zod";
import { resourceGenericZodObject } from "./resource-generic";
import { resourceGroupZodObject } from "./resource-group";
import { isResourceLocal, resourceLocalZodSchema } from "./resource-local";
import { resourceReservedZodObject } from "./resource-reserved";
import { isResourceShared, resourceSharedZodSchema } from "./resource-shared";
import { resourceTableZodObject } from "./resource-table";
import {
    nonGroupResourceTypes,
    type NonGroupResourceType,
} from "./resource-type";

// type Resource =
//     | ResourceShared
//     | ResourceLocal
//     | ResourceGroup
//     | ResourceGeneric
//     | ResourceTable
//     | ResourceAccommodation
//     | ResourceReserved;

const isResource = (item: unknown): item is Resource => {
    return (
        isResourceLocal(item) ||
        isResourceShared(item) ||
        isResourceGlobal(item)
    );
};

const resourceButNotResourceGroupZodSchema = z.union([
    resourceGenericZodObject,
    resourceTableZodObject,
    resourceAccommodationZodObject,
    resourceLocalZodSchema,
    resourceSharedZodSchema,
    resourceReservedZodObject,
    resourceTableGroupZodObject,
]);

/** Any resource type except for RESOURCE_GROUP */
type NonGroupResource = z.infer<typeof resourceButNotResourceGroupZodSchema>;

// Make sure the type is correct and matches the expected type
assertTypeMatch<IsEqual<NonGroupResourceType, NonGroupResource["_type"]>>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isNonGroupResource = (resource: any): resource is NonGroupResource => {
    return !!nonGroupResourceTypes.includes(resource?._type);
};

const resourceZodSchema = z.union([
    resourceButNotResourceGroupZodSchema,
    resourceGroupZodObject,
    resourceTableGroupZodObject,
]);

type Resource = z.infer<typeof resourceZodSchema>;

export {
    isNonGroupResource,
    isResource,
    resourceButNotResourceGroupZodSchema,
    resourceZodSchema,
};
export type { NonGroupResource, Resource };
